import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/design-system/primitives/Toast";
import { AuthProvider } from "@/modules/auth/AuthContext";
import { AppRoutes } from "@/app/routes/AppRoutes";

const queryClient = new QueryClient();

const App = () => (
  <Sentry.ErrorBoundary fallback={<div className="flex min-h-screen items-center justify-center ds-surface-card ds-text-heading text-sm">Something went wrong. Please refresh the page.</div>}>
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem storageKey="integritty-theme">
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Toaster />
        <AppRoutes />
      </AuthProvider>
    </QueryClientProvider>
  </ThemeProvider>
  </Sentry.ErrorBoundary>
);

export default App;
